import EmailIcon from "@assets/icons/email.svg";

import { openThreadPage } from "@utils/navigation.util";
import { IThreadTagResponse } from "@interfaces/responses.interface";
import { TagWrapper } from "./TagWrapper";
import { TagLabel } from "@ui/Content";
import { View } from "@ui/View";

interface Props {
  data: IThreadTagResponse;
  isDisabled: boolean;
  onAdd?: (tag: IThreadTagResponse) => void;
  onRemove?: (tag: IThreadTagResponse) => void;
  withPlusIcon?: boolean;
  iconOnly?: boolean;
}

export function ThreadTag({ data, isDisabled, onAdd, onRemove, withPlusIcon, iconOnly }: Props) {
  return (
    <TagWrapper
      data={data}
      isDisabled={isDisabled}
      onRemove={onRemove}
      onRedirect={() => openThreadPage(data.object.id)}
      withPlusIcon={withPlusIcon}
      onAdd={onAdd}
    >
      <EmailIcon
        width={20}
        height={20}
        className="flex-shrink-0 text-[#6B7080] dark:text-invertedPrimary80"
      />

      <View.Condition if={!iconOnly}>
        <TagLabel className="mr-1">{data.object.subject}</TagLabel>
      </View.Condition>
    </TagWrapper>
  );
}
